import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 190.16 190.17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M190.16 98.46V91.7h-54.58c-.41-4.95-1.72-9.64-3.75-13.94l47.29-27.3-3.38-5.85-47.27 27.29a40.894 40.894 0 0 0-10.2-10.21l27.3-47.28-5.85-3.38-27.3 47.29c-4.38-2.08-9.1-3.35-13.93-3.75V0h-6.76v54.58c-4.95.41-9.64 1.72-13.93 3.75L50.5 11.04l-5.85 3.38 27.3 47.28a40.894 40.894 0 0 0-10.2 10.21L14.48 44.62l-3.38 5.85 47.29 27.3a40.265 40.265 0 0 0-3.75 13.94H0v6.76h54.58c.41 4.95 1.72 9.64 3.75 13.93l-47.29 27.3 3.38 5.85 47.28-27.29c2.77 3.98 6.23 7.44 10.21 10.21l-27.29 47.28 5.85 3.38 27.3-47.29c4.29 2.03 8.98 3.34 13.93 3.75v54.58h6.76v-54.58c4.95-.41 9.64-1.72 13.93-3.75l27.3 47.29 5.85-3.38-27.29-47.28c3.98-2.77 7.44-6.23 10.21-10.21l47.28 27.29 3.38-5.85-47.29-27.3c2.03-4.29 3.34-8.98 3.75-13.93h54.58Zm-95.08 30.52c-18.7 0-33.91-15.21-33.91-33.91s15.21-33.91 33.91-33.91 33.91 15.21 33.91 33.91-15.21 33.91-33.91 33.91Z",
  style: {"fill":"#181716"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }